import { TypeSeoTagsWithoutUnresolvableLinksResponse } from 'contentful-types'
import NextHead from 'next/head'

import serializeJsonLd from './StructuredDataFactory/serializeJsonLd'

import { getSEOMetadata } from './SEO/metadata'
import { Language } from '../../locale'

export interface HeadProps {
  title: string
  seo?: TypeSeoTagsWithoutUnresolvableLinksResponse['fields']
  language?: Language
  // JSON-LD resolved on the server (see resolveStructuredData), so the raw
  // payloads stay out of __NEXT_DATA__. `null`/undefined => no structured data.
  // Typed `unknown` because JSON-LD may be an object, an array, or a `@graph`.
  // See docs/adr/0001.
  jsonLd?: unknown
  slug?: string
}

export const Head = ({ seo, jsonLd, slug, language, title }: HeadProps) => {
  const metaData = getSEOMetadata(seo, language, slug, title)

  return (
    <NextHead>
      <title>{title}</title>
      {metaData.meta.map((meta, index) => (
        <meta key={`m-${index}`} name={meta.name} property={meta.property} content={meta.content} />
      ))}
      {metaData.link.map((link, index) => (
        <link key={`l-${index}`} rel={link.rel} href={link.href} hrefLang={link?.hreflang} />
      ))}
      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: serializeJsonLd(jsonLd),
          }}
        />
      )}
    </NextHead>
  )
}

export default Head
